/**
 * Form field wrapper (PHASE1 §7.4): label + optional hint + validation error
 * around any control. Generates an id so the label and control are associated.
 */
import { useId, type ReactNode } from 'react';

export interface FieldProps {
  label: string;
  hint?: string;
  error?: string | null;
  required?: boolean;
  /** Render prop receives the generated control id for `htmlFor`/`id` wiring. */
  children: (id: string) => ReactNode;
}

export function Field({ label, hint, error, required, children }: FieldProps) {
  const id = useId();
  return (
    <div className="space-y-1.5">
      <label htmlFor={id} className="block text-sm font-medium text-slate-700 dark:text-slate-300">
        {label}
        {required ? <span className="ml-0.5 text-rose-500">*</span> : null}
      </label>
      {children(id)}
      {error ? (
        <p className="text-xs text-rose-600 dark:text-rose-400">{error}</p>
      ) : hint ? (
        <p className="text-xs text-slate-400 dark:text-slate-500">{hint}</p>
      ) : null}
    </div>
  );
}
